import React from "react";
import { useState, Fragment } from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
 
export default function DropDownQuestion({question, answer, index, handleOpen, open}) {

 
  const customAnimation = {
    mount: { scale: 1 },
    unmount: { scale: 0.9 },
  };
 
  return (
    <div className="lg:w-[90%] md:w-[95%] w-[100%] mx-auto px-8 py-3 rounded-lg">
    <Fragment>
      <Accordion open={open === index} animate={customAnimation} className="px-3 bg-white rounded-lg shadow-inner">
        <AccordionHeader onClick={() => handleOpen(index)} className="break-all">
          {question}
        </AccordionHeader>
        <AccordionBody className='break-words'>
          {answer}
        </AccordionBody>
      </Accordion>
    </Fragment>
    </div>
  );
}